import { jsx } from "react/jsx-runtime";
import { DecoratorNode } from "lexical";
import { ImagesGallery } from "../../plugins/index.js";
import { $createImagesGalleryNode, $isImagesGalleryNode } from "./ImagesGalleryNode.helpers.js";
class ImagesGalleryNode extends DecoratorNode {
    static getType() {
        return 'images-gallery';
    }
    getIds() {
        return this.images.map(({ id })=>id);
    }
    decorate(editor) {
        return /*#__PURE__*/ jsx(ImagesGallery, {
            images: this.images,
            description: this.description,
            editable: editor._editable
        });
    }
    static clone(node) {
        return new ImagesGalleryNode(node.images, node.editor, node.description, node.__key);
    }
    createDOM() {
        return document.createElement('span');
    }
    exportJSON() {
        return {
            type: 'images-gallery',
            version: 1,
            images: this.images,
            description: this.description
        };
    }
    updateDOM(prevNode) {
        const isImagesGalleryNode = $isImagesGalleryNode(prevNode);
        if (!isImagesGalleryNode) return true;
        const shouldUpdate = this.description !== prevNode.description || this.images.length !== prevNode.images.length || this.images.some((img, index)=>{
            const prevImg = prevNode.images[index];
            return !prevImg || img.name !== prevImg.name;
        });
        return shouldUpdate;
    }
    static importJSON(serializedNode) {
        return $createImagesGalleryNode(serializedNode.images, null, serializedNode.description);
    }
    getTextContent() {
        return this.description || '';
    }
    constructor(images, editor, description, key){
        super(key);
        this.images = images;
        this.editor = editor;
        this.description = description;
    }
}
export { ImagesGalleryNode };
